import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import "./static/OverviewView.scss";
import { IServicesProvider } from "../../../di/IServicesProvider";
import OverviewAnalytics, { OverviewAnalyticsModel } from "../OverviewAnalytics/OverviewAnalytics";
import BaseComponent from "../../../utility/BaseComponent";
import LatestActivityTable, { LatestActivityTableModel } from "../LatestActivityTable/LatestActivityTable";
import { IBaseModel } from "../../../utility/IBaseModel";
export class OverviewViewModel implements IBaseModel {
    
    @observable servicesProvider: IServicesProvider;
    constructor (servicesProvider: IServicesProvider) {
        this.servicesProvider = servicesProvider;
    }
    // tslint:disable-next-line:no-empty
    prepare() {
    }
}

@observer class OverviewView extends BaseComponent<{model: OverviewViewModel}, {}> {
    
    render() {
        return(
            <div className="OverviewContainer GeneralViewContainer">
            <div className="row"> 
            <h1>Welcome, {this.props.model.servicesProvider.getUser().name}</h1>
            </div>            
            <div className="row"> 
                <h2>Overview</h2>
                <OverviewAnalytics 
                        model={
                        new OverviewAnalyticsModel(this.props.model.servicesProvider)
                        } 
                />
            </div>
            <div className="row">
                <h2>Latest Activity</h2>
                <LatestActivityTable
                    model={
                        new LatestActivityTableModel(this.props.model.servicesProvider)
                        } 
                />
            </div>
            </div>
        );
    }
}
export default OverviewView;


// WEBPACK FOOTER //
// ./src/view/Admin/OverviewView/OverviewView.tsx